import { action } from 'typesafe-actions';
import { IApiQueryOptions } from 'api/ApiClient';
import { IApiList, IPaymentSet } from 'types';
import { Payments } from './types';

export const getSitePaymentsRequest = (siteId: string, options?: IApiQueryOptions) => action(Payments.GET_SITE_PAYMENTS_REQUEST, { siteId, options });
export const getSitePaymentsSuccess = (response: IApiList<IPaymentSet>) => action(Payments.GET_SITE_PAYMENTS_SUCCESS, response);
export const getSitePaymentsError = (error: any) => action(Payments.GET_SITE_PAYMENTS_FAIL, error);
